export default __webpack_public_path__ + "static/checknlearn-promo-small@1x-788530cc8ecfeef4fd58de558aa267e0.jpg";